import * as React from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import { AppUserContext, SessionContext } from "../providers";

type LegacyRedirectProps = RouteComponentProps<{ [key: string]: string }> & {
  getTo: (
    userContext: AppUserContext | undefined,
    routeProps: RouteComponentProps<{ [key: string]: string }>
  ) => string;
};

export const LegacyRedirectRoute: React.FC<LegacyRedirectProps> = ({ getTo, ...routeProps }) => {
  return (
    <SessionContext.Consumer>
      {({ userContext, loading }) => {
        if (loading) {
          return <Loader active size="large" />;
        }

        const to = getTo(userContext, routeProps);
        return <Redirect exact to={to} />;
      }}
    </SessionContext.Consumer>
  );
};
